import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useIntendedUrl } from '~src/main/hooks/useIntendedUrl';

export function AppLoginCallback() {
  const intended = useIntendedUrl();
  const url = intended.get();

  /**
   * React triggers multiple renderds due to strict mode,
   * meaning, if we would clear the value directly, react
   * would redirect to the fallback value, which is "/".
   *
   * Therefore we're doing the redirect, and after 1s, we clear it,
   * just to eliminate the risk of a race condition.
   */
  useEffect(() => {
    setTimeout(() => intended.clear(), 2500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Navigate to={url ?? '/'} />;
}
